module.exports = __webpack_public_path__ + "static/media/finishProcessPage.10bc5485.jpg";